export default {
  scope: ({ site, path }) => site.includes('vidawool') || path.includes('vidawool'),
  colors: { brand: '#005640' },
  fonts: { heading: 'Roboto Slab, sans-serif' },
  icons: { tools: { textColor: 'BrandVidawool' } }
};
